import type { Theme } from '../types';

export const DEFAULT_THEME: Theme = {
  primary: 'bg-white',
  secondary: 'bg-blue-600',
  text: 'text-gray-900',
  hover: 'hover:bg-blue-700',
  accent: 'bg-blue-50',
  header: 'bg-white',
};
